app.directive('durationPicker', ['portalHelper',
  function (portalHelper) {
    return {
      require: 'ngModel', // this is important,
      scope: {
        maxDays: '<',
        stepHours: '<',
        showDays: '<',
        showHours: '<',
        showMinutes: '<',
        showSeconds: '<',
        changeMethod: '<',
        disabled: '<'
      },
      link: function (scope, elt, attrs, ngModelCtrl) { // ctrl here is the ngModelCtrl
        scope.$watch('minutes + hours + days', function () {
          // update the ngModel.viewValue from our component variables when they change
          // this ensures that ng-change on the directive get fired where appropriate
          let value = '';
          let sep = '';

          if (scope.showDays && scope.showHours) {
            // D HH:MM:SS format
            if (scope.showDays) {
              value += sep + scope.format_number(scope.days);
              sep = ':';
            }

            if (scope.showHours) {
              value += sep + scope.format_number(scope.hours);
              sep = ':';
            }

            if (scope.showMinutes) {
              value += sep + scope.format_number(scope.minutes);
              sep = ':';
            }

            value = scope.days + ' ' + scope.format_number(scope.hours) + ':00:00';
          } else {
            // hh:mm format

            if (scope.showDays) {
              value += sep + scope.format_number(scope.days);
              sep = ':';
            }

            if (scope.showHours) {
              value += sep + scope.format_number(scope.hours);
              sep = ':';
            }

            if (scope.showMinutes) {
              value += sep + scope.format_number(scope.minutes);
              sep = ':';
            }
          }

          ngModelCtrl.$setViewValue(value); // this line will automatically eval your ng-change
        });

        ngModelCtrl.$formatters.push(function (modelValue) {
          if (modelValue == null) {
            return;
          }
          // set our component variables (days, hours, minutes) from the initial attribute passed
          scope.minutes = scope.hours = scope.days = scope.seconds = 0;
          const values = modelValue.split(':');

          if (values.length === 2) {
            // hh:mm format
            if (scope.showMinutes) {
              scope.minutes = parseInt(values.pop());
            }

            if (scope.showHours) {
              scope.hours = parseInt(values.pop());
            }

            if (scope.showDays) {
              scope.days = parseInt(values.pop());
            }
          } else {
            // D HH:MM:SS format
            const myRegexp = /^(\d)+ (\d{2}):(\d{2}):(\d{2})$/g;

            const match = myRegexp.exec(modelValue);
            if (match) {
              if (scope.showSeconds) {
                scope.minutes = parseInt(match[4]);
              }

              if (scope.showMinutes) {
                scope.minutes = parseInt(match[3]);
              }

              if (scope.showHours) {
                scope.hours = parseInt(match[2]);
              }

              if (scope.showDays) {
                scope.days = parseInt(match[1]);
              }
            }
          }
        });

        if (scope.maxDays === undefined) {
          scope.maxDays = 50;
        }

        if (scope.showHours === undefined) {
          scope.showHours = true;
        }

        if (scope.stepHours === undefined) {
          scope.stepHours = 1;
        }

        scope.minutes_list = [];
        scope.hours_list = [];
        scope.days_list = [];

        scope.format_number = function (num) {
          //return num;
          return ('0' + num).substr(-2);
        };

        for (let i = 0; i < 60; i += 5) {
          scope.minutes_list.push(i);
        }

        for (let i = 0; i < 24; i += scope.stepHours) {
          scope.hours_list.push(i);
        }

        for (let i = 0; i <= scope.maxDays; i += 1) {
          scope.days_list.push(i);
        }
      },
      templateUrl: portalHelper.getUrlRev('html_templates/directives/duration_picker.0bc673ef.html')
    };
  }]
);
